<template>
  <v-app>
      <loader v-if="loader" style="z-index: 1000; position: fixed;"/> 
      <router-view ></router-view>
  </v-app>
</template>

<script>
import loader from '@/components/loader.vue';

export default {
  name: 'App',

  components: {
    loader
  },

  data: () => ({
    loader: true
  }),
  created() {
    
  },
  mounted() {
    this.showLoader();
  },
  methods: {
    showLoader() {
      setTimeout(() => {
        this.loader = false;
      }, 2000);
    }
  },
};
</script>